<div class="header flex items-center">
  <div class="skins-price">
    Total Value:
    <app-cost [gap]="4" [cost]="totalValue() ?? 0"></app-cost>
  </div>
  @if (typeof rake() === 'number') {
  <div class="rake">
    Rake:
    <app-cost color="var(--red)" [gap]="4" [cost]="rake() ?? 0"></app-cost>
  </div>
  }
  <div class="game-id-wrapper">
    <div
      class="gameid"
      (click)="clipboardService.copy(gameid(), 'GameID copied to clipboard')"
    >
      GameID:
      {{ gameid() }}
    </div>
  </div>
</div>
<div class="divider horizontal w-full"></div>
<div class="skins">
  @if (adminGameSkins.error()) {
  <div
    style="text-align: center"
    class="flex flex-col gap-4 items-center justify-center w-full h-full"
  >
    {{ adminGameSkins.error() }}
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="adminGameSkins.reload()"
    >
      Reload
    </button>
  </div>
  } @else if (adminGameSkins.isLoading()) {
  <div class="skins--skeleton">
    @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14, 15, 16, 17, 18, 19,
    20]; track $index) {
    <div
      class="h-full w-full skeleton-animation rounded-4"
      style="background: var(--gray-24); height: 100%"
    ></div>
    }
  </div>
  } @else {
  <app-skins-list
    animate.enter="animate-fade-in"
    [skins]="adminGameSkins.value() ?? []"
    [config]="{ mobile: { skin_min_width: '130px' } }"
    (openUserProfile)="handleOpenAdminUserProfile($event)"
  />
  @if ((adminGameSkins.value()?.length ??0) === 0) {
  <div
    animate.enter="animate-fade-in"
    class="w-full flex flex-col gap-4 items-center absolute-center"
  >
    <span class="typography-title">No items found, try reload </span>
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="adminGameSkins.reload()"
    >
      Reload
    </button>
  </div>
  } }
</div>
